<template>
  <label class="image-switch" :style="sliderWrapperStyle" ref="wrapper">
    <input type="checkbox" @change="updateInput" :checked="isChecked" :value="value">
    <span class="slider"></span>
  </label>
</template>

<script>
export default {
  name: "ImageSwitch",

  model: {
    prop: "modelValue",
    event: "change"
  },
  props: {
    // v-model props
    value: {
      type: String
    },
    modelValue: {
      type: Boolean,
    },
    trueValue: {
      default: true
    },
    falseValue: {
      default: false
    },
    // custom props
    falseImg: {
      default: "",
    },
    trueImg: {
      default: "",
    },
    falseBGColor: {
      default: "red",
    },
    trueBGColor: {
      default: "green",
    },
    falseMarkerColor: {
      default: "white",
    },
    trueMarkerColor: {
      default: "white",
    },
    falseMarkerImg: {
      default: "",
    },
    trueMarkerImg: {
      default: "",
    },
    falseMarkerImgSize: {
      default: "cover",
    },
    trueMarkerImgSize: {
      default: "cover",
    },
    // sizing
    height: {
      type: String,
      default: "auto",
    },
    width: {
      type: String,
      default: "auto",
    },
  },

  data() {
    return {
      bgColor: "none",
      markerColor: "white",
      markerImg: "",
      markerImgSize: "",
      resizeWidth: this.width,
      switchMarkerOffset: "5px",
    };
  },

  computed: {
    isChecked() {
      if (this.modelValue instanceof Array) {
        return this.modelValue.includes(this.value)
      }
      return this.modelValue === this.trueValue
    },
    sliderWrapperStyle() {
      return {
        width: this.width,
        height: this.height,
        "--image-switch-width": this.resizeWidth,
        "--image-switch-background-color": this.bgColor,
        "--image-switch-marker-color": this.markerColor,
        "--image-switch-marker-offset-lr": this.switchMarkerOffset,
        "--image-switch-marker-img-url": `url('${this.markerImg}')`,
        "--image-switch-marker-img-size": this.markerImgSize,
      };
    },
  },

  watch: {
    isChecked:  {
      immediate: true,
      handler(value) {
        if (value) {
          this.bgColor = this.trueBGColor;
          this.markerColor = this.trueMarkerColor;
          this.markerImg = this.trueMarkerImg;
          this.markerImgSize = this.trueMarkerImgSize;
        } else {
          this.bgColor = this.falseBGColor;
          this.markerColor = this.falseMarkerColor;
          this.markerImg = this.falseMarkerImg;
          this.markerImgSize = this.falseMarkerImgSize;
        }
      },
    },
  },

  created() {
    window.addEventListener("resize", this.onWindowResize.bind(this));
  },
  destroyed() {
    window.removeEventListener("resize", this.onWindowResize.bind(this));
  },

  mounted() {
    this.$nextTick(() => {
      this.onWindowResize();
    })
  },

  methods: {
    updateInput(event) {
      let isChecked = event.target.checked
      if (this.modelValue instanceof Array) {
        let newValue = [...this.modelValue]
        if (isChecked) {
          newValue.push(this.value)
        } else {
          newValue.splice(newValue.indexOf(this.value), 1)
        }
        this.$emit("change", newValue)
      } else {
        this.$emit("change", isChecked ? this.trueValue : this.falseValue)
      }
    },

    /**
     * Event listeners
     */
    onWindowResize() {
      function convertRemToPixels(rem) {
        return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
      }
      let actualWidth = this.$refs.wrapper.clientWidth;

      let variableWidth = parseFloat(this.width);
      if (this.width.includes("rem")) {
        variableWidth = convertRemToPixels(variableWidth);
      }

      this.resizeWidth = Math.max(Math.min(actualWidth, variableWidth), parseFloat(this.switchMarkerOffset)*2) + "px";
    },
  },
}
</script>

<style scoped>
.image-switch {
  position: relative;
  display: inline-block;
  margin: 0;
}

/* Hide default HTML checkbox */
.image-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--image-switch-background-color);
  -webkit-transition: .4s;
  transition: .4s;

  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 80%;
  aspect-ratio: 1/1;

  bottom: 10%;
  left: var(--image-switch-marker-offset-lr);
  background-color: var(--image-switch-marker-color);
  -webkit-transition: .4s;
  transition: .4s;

  border-radius: 50%;

  background-size: var(--image-switch-marker-img-size);
  background-repeat: no-repeat;
  background-position: center;
  background-image: var(--image-switch-marker-img-url);

}

input:checked + .slider {}

input:focus + .slider {}

input:checked + .slider:before {
  -webkit-transform: translateX(calc(var(--image-switch-width) - 100% - var(--image-switch-marker-offset-lr)*2));
  -ms-transform: translateX(calc(var(--image-switch-width) - 100% - var(--image-switch-marker-offset-lr)*2));
  transform: translateX(calc(var(--image-switch-width) - 100% - var(--image-switch-marker-offset-lr)*2));
}

</style>
